import DefaultErrorPage from './errorPages/default';
import DefaultModalErrorPage from './errorPages/defaultModal';
import ShopErrorPage from './errorPages/shop';
import { ERROR_PAGES } from './utils';

const ERROR_TO_PRINT = {
  [ERROR_PAGES.DEFAULT]: (props) => <DefaultErrorPage {...props} />,
  [ERROR_PAGES.SHOP]: (props) => <ShopErrorPage {...props} />,
  [ERROR_PAGES.DEFAULT_MODAL]: (props) => <DefaultModalErrorPage {...props} />,
};

export default ERROR_TO_PRINT;
